import styled from 'styled-components';
import { BottomSns } from '../../common/BottomSnsImg';
import { SUB_TAB_STATUS } from '../../../types/type';
import { mobileQuery } from '../../../utils';
import { OnlineInfo } from './OnlineInfo';
import { OfflineInfo } from './OfflineInfo';

export const ParticipationInfo = ({
  setSubTab,
  subTab,
}: {
  setSubTab: (n: SUB_TAB_STATUS) => void;
  subTab: SUB_TAB_STATUS;
}) => {
  return (
    <>
      <Wrap>
        <TabContainer>
          <ClickTabOnline
            $isActive={subTab === SUB_TAB_STATUS.ONLINE}
            onClick={() => setSubTab(SUB_TAB_STATUS.ONLINE)}
          >
            <TabText $isActive={subTab === SUB_TAB_STATUS.ONLINE}>온라인 새틀라이트</TabText>
          </ClickTabOnline>
          <ClickTabOffline
            $isActive={subTab === SUB_TAB_STATUS.OFFLINE}
            onClick={() => setSubTab(SUB_TAB_STATUS.OFFLINE)}
          >
            <TabText $isActive={subTab === SUB_TAB_STATUS.OFFLINE}>오프라인 이벤트</TabText>
          </ClickTabOffline>
        </TabContainer>

        {subTab === SUB_TAB_STATUS.ONLINE && <OnlineInfo />}
        {subTab === SUB_TAB_STATUS.OFFLINE && <OfflineInfo />}
      </Wrap>
      <BottomSns />
    </>
  );
};

const Wrap = styled.div`
  padding-top: 20px;

  ${mobileQuery} {
    padding-top: 15px;
    padding-left: 10px;
    padding-right: 10px;
  }
`;

const Tab = styled.div`
  display: flex;
  height: 50px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s;
  background-color: #434343;
  border: 2px solid #434343;
  flex: 1;

  ${mobileQuery} {
    height: 34px;
  }
`;
const ClickTabOnline = styled(Tab)<{ $isActive: boolean }>`
  ${({ $isActive }) =>
    $isActive
      ? 'border: 2px solid rgba(65, 192, 255, 0.13); background: linear-gradient(95deg, #FFF -29.93%, #E8F1FF 121.97%);'
      : ''}
  margin-right: 20px;

  ${mobileQuery} {
    margin-right: 12px;
  }
`;

const ClickTabOffline = styled(Tab)<{ $isActive: boolean }>`
  ${({ $isActive }) =>
    $isActive
      ? 'border: 2px solid rgba(65, 192, 255, 0.13); background: linear-gradient(95deg, #FFF -29.93%, #E8F1FF 121.97%);'
      : ''}
`;

const TabContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 21px;
  padding-left: 25px;
  padding-right: 25px;

  ${mobileQuery} {
    margin-bottom: 21px;
    padding-left: 5px;
    padding-right: 5px;
  }
`;

const TabText = styled.h3<{ $isActive: boolean }>`
  color: ${({ $isActive }) => ($isActive ? '#000' : 'rgba(255, 255, 255, 0.50)')};

  text-align: center;
  font-size: ${({ $isActive }) => ($isActive ? '22px' : '20px')};
  font-weight: ${({ $isActive }) => ($isActive ? '600' : '500')};

  ${mobileQuery} {
    font-size: 16px;
    line-height: 20px;
  }
`;
